import styled from 'styled-components';
import { Palette } from 'core/config';
import { ImUser } from 'react-icons/im';
import { GoCalendar } from 'react-icons/go';
import { IoIosCall } from 'react-icons/io';
import { IoClose } from 'react-icons/io5';
import { HiOutlineArrowNarrowLeft } from 'react-icons/hi';
import { MdLocationOn } from 'react-icons/md';
import { BiEdit } from 'react-icons/bi';
import { FiCheck } from 'react-icons/fi';

export const ProfileContainer = styled.div`
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
`;

export const ProfileForm = styled.div`
    margin-top: 8rem;
    width: 40rem;
    background-color: ${Palette.TAN};
    border-radius: 3rem;
    padding: 4rem 2rem;
    box-sizing: border-box;
    font-family: SofiaPro-Regular;
    height: fit-content;

    @media only screen and (max-width: 600px) {
        width: 95%;
    }
`;

export const FormContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    @media only screen and (max-width: 600px) {
        margin-top: 1.5rem;
    }
`;

export const Heading = styled.div`
    margin: 1rem 0;
    font: normal normal normal 28px 'SofiaPro-Bold';
    font-weight: 500;
    color: ${Palette.BLUE};
`;

export const Subheading = styled.p`
    text-align: center;
    margin-bottom: 2rem;
    padding: 0 3rem;
    box-sizing: border-box;
    font-size: 14px;
    color: ${Palette.BLUE};

    @media only screen and (max-width: 600px) {
        padding: 0 1.5rem;
        font-size: 12px;
    }
`;

export const InfoTab = styled.div<{ editMode?: boolean, addressTab?: boolean }>`
    background-color: white;
    height: 5rem;
    width: 26rem;
    padding: 1rem 2rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-radius: 10px;
    margin-bottom: 1rem;
    transition: transform 0.5s, height 0.5s;

    ${({ editMode }) => editMode && `
        transform: scale(1.2);
    `}

    ${({ editMode, addressTab }) => editMode && addressTab && 'height: 8rem;'}

    @media only screen and (max-width: 600px) {
        width: 100%;
    }
`;

export const UserIcon = styled(ImUser)`
    color: ${Palette.ORANGE};
    font-size: 1.5rem;
`;

export const CalendarIcon = styled(GoCalendar)`
    color: ${Palette.ORANGE};
    font-size: 1.5rem;
`;

export const PhoneIcon = styled(IoIosCall)`
    color: ${Palette.ORANGE};
    font-size: 1.5rem;
`;

export const LocationIcon = styled(MdLocationOn)`
    color: ${Palette.ORANGE};
    font-size: 1.5rem;
`;

export const EditIcon = styled(BiEdit)`
    color: ${Palette.ORANGE};
    font-size: 1.5rem;
`;

export const SaveIcon = styled(FiCheck)`
    color: ${Palette.TEAL};
    font-size: 1.5rem;
`;

export const CloseIcon = styled(IoClose)`
    color: ${Palette.ORANGE};
    font-size: 1.5rem;
    transform: translatey(1px);
`;

export const IconButton = styled.button<{ backBtn?: boolean, saveBtn?: boolean }>`
    border-radius: 50%;
    border: none;
    padding: 0;
    background: transparent;
    cursor: pointer;

    ${({ backBtn }) => backBtn && `
        margin-left: 2rem;
        display: flex;
        align-items: center;
        gap: 1rem;

        @media only screen and (max-width: 600px) {
            margin-left: 1rem;
        }
    `}

    ${({ saveBtn }) => saveBtn && `
        margin-right: 0.3rem;
    `}
`;

export const BackButtonText = styled.span`
    font-size: 1rem;
    font-family: SofiaPro-Regular;
    color: ${Palette.BLUE};

    @media only screen and (max-width: 600px) {
        font-size: 0.8rem;
    }
`;

export const BackArrowIcon = styled(HiOutlineArrowNarrowLeft)`
    font-size: 1.2rem;
    color: ${Palette.BLUE};
`;

export const Info = styled.p`
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: ${Palette.BLUE};

    @media only screen and (max-width: 600px) {
        font-size: 12px;
    }
`;

export const InputField = styled.input`
    width: 100%;
    height: 2rem;
    padding-left: 1rem;
    padding-right: 1rem;
    box-sizing: border-box;
    border: none;
    margin-left: 1rem;
    margin-right: 1rem;
    font-family: SofiaPro-Regular;
    color: ${Palette.BLUE};
    border-bottom: 1px solid ${Palette.ORANGE};
    
    &:focus {
        outline: none;
        border-radius: 5px;
        border: 1px solid ${Palette.ORANGE};
    }
`;

export const DropdownContainer = styled.div`
    position: absolute;
    top: 3.5rem;
    left: 3rem;
    color: ${Palette.BLUE};
    font-size: 12px;
    z-index: 1;
    box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12);

    div {
        padding: 0.5rem 1rem;
    }
`;

export const DropdownItem = styled.div`
    cursor: pointer;
    background-color: ${Palette.WHITE};

    &:hover {
        background-color: ${Palette.EGGSHELL_WHITE};
    }
`;

export const FieldGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    margin-left: 1rem;
    margin-right: 1rem;

    input {
        margin: 0;
    }
`;

export const SuiteField = styled.div`
    display: flex;
    gap: 1rem;
`;

export const SelectField = styled.select`
    border: none;
    border-bottom: 1px solid ${Palette.ORANGE};
    font-family: SofiaPro-Regular;
    color: ${Palette.BLUE};
    font-size: 12px;
`;

export const DefaultText = styled.span`
    color: ${Palette.GREY};
`;
